import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { filterDates } from 'components/formElements/DateRange';
import { Activity } from 'constants/activity.constants';
import { defineds } from 'constants/ui.constants';
import _ from 'lodash';

interface activityState {
	startLoadingActivities: boolean;
	loadingActivities: boolean;
	activities: Activity[];
	activitiesObject: Record<string, any>;
	startDate?: Date;
	endDate?: Date;
	navbarSearchStartDate?: Date;
	navbarSearchEndDate?: Date;
	isLoading: boolean;
}

const initialState: activityState = {
	startLoadingActivities: false,
	loadingActivities: false,
	activities: [],
	activitiesObject: {},
	startDate: defineds.startOfLast365Day,
	endDate: defineds.endOfMonth,
	navbarSearchStartDate: defineds.startOfLast365Day,
	navbarSearchEndDate: defineds.endOfMonth,
	isLoading: false,
};

export const activitySlice = createSlice({
	name: 'activity',
	initialState,
	reducers: {
		setStartLoadingActivities: (state: any) => {
			state.startLoadingActivities = true;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loadingActivities = action.payload;
		},
		setActivities: (state, action: PayloadAction<Activity[]>) => {
			state.activities = action.payload;
			state.activitiesObject = _.keyBy(action.payload, 'reference');
		},
		setActiveDates: (state, action: PayloadAction<filterDates>) => {
			state.startDate = action.payload.startDate;
			state.endDate = action.payload.endDate;
		},
		setNavbarSearchActiveDates: (state, action: PayloadAction<filterDates>) => {
			state.navbarSearchStartDate = action.payload.startDate;
			state.navbarSearchEndDate = action.payload.endDate;
		},
	},
});

export const {
	setStartLoadingActivities,
	setLoading,
	setActivities,
	setActiveDates,
	setNavbarSearchActiveDates,
} = activitySlice.actions;

const activitySelector = (state) => state.activity;

export const getActivities = (state: any) => {
	return state.activity.activities;
};

export const getActivity = (reference: string) => (state: any) => {
	return _.get(state.activity.activitiesObject, reference);
};

export const loadingActivities = createSelector([activitySelector], (state: any) => {
	return {
		loadingActivities: state.loadingActivities,
		startLoadingActivities: state.startLoadingActivities,
	};
});

export const getActivityDates = createSelector([activitySelector], (state: any) => {
	return { startDate: state.startDate, endDate: state.endDate };
});
export const getNavbarSearchActivityDates = createSelector([activitySelector], (state: any) => {
	return { startDate: state.navbarSearchStartDate, endDate: state.navbarSearchEndDate };
});
export default activitySlice.reducer;
